import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, useInnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Impact Figures Inner",
}

export default defineBlock("section/impact-figures-inner", (props) => {
  const inner = useInnerBlocks()
  const total = inner.length

  return (
    <div
      className={cn(
        "impact-figures-inner w-full max-w-blogPostVideoW mx-auto",
        !env.admin && "grid grid-cols-1 gap-4",
        !env.admin && total === 2 && "md:grid-cols-2",
        !env.admin && total >= 3 && "md:grid-cols-3",
      )}
    >
      <InnerBlocks
        allowedBlocks={["section/impact-figures-inner-card"]}
        adminClassName={cn("grid grid-cols-1 gap-4", total === 2 && "md:grid-cols-2", total >= 3 && "md:grid-cols-3")}
        template={[
          ["section/impact-figures-inner-card", {}],
          ["section/impact-figures-inner-card", {}],
          ["section/impact-figures-inner-card", {}],
        ]}
      />
    </div>
  )
})
